import { useState } from "react";
import styles from "styles/Category.module.scss";
import Card from "components/Card";
import Title from "components/Title";
import SearchBar from "components/SearchBar";
import useMakeRequest from "hooks/useMakeRequest";
import { useParams } from "react-router-dom";
import config from "../config";

const Category = () => {
    const { slug } = useParams();
    const result = useMakeRequest(`${config.API_BASE_URL}/products/category/${slug}`);

    const [searchTerm, setSearchTerm] = useState("");

    if (!result.data) {
        return (
            <div style={{ width: "100%", display: "flex", justifyContent: "center", marginTop: "30px" }}>
                <Title txt="Loading..." size={25} transform="uppercase" />
            </div>
        );
    } else {
        // Filter out products with quantity <= 0 and apply search filtering
        const filteredData = searchTerm
            ? result.data
                .filter(product => product.quantity > 0)  // Exclude products with quantity <= 0
                .filter((product) =>
                    product.title && typeof product.title === "string" &&
                    product.title.toLowerCase().includes(searchTerm.toLowerCase())
                )
            : result.data.filter(product => product.quantity > 0);  // Default filtering for quantity

        const handleSearch = (query) => {
            setSearchTerm(query);
        };

        return (
            <section className={styles.category}>
                <div className={styles.container}>
                    <div className={styles.row}>
                        {result.data && (
                            <div className={styles.title}>
                                <Title txt={slug} color="#171717" size={22} transform="uppercase" />
                            </div>
                        )}
                        <SearchBar onSearch={handleSearch} />
                    </div>
                    <div className={styles.row}>
                        {filteredData.length > 0 ? (
                            filteredData.map((product, key) => <Card product={product} key={key} />)
                        ) : (
                            <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
                                <Title txt="No products found" size={25} transform="uppercase" />
                            </div>
                        )}
                    </div>
                </div>
            </section>
        );
    }
};

export default Category;
